import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useScalable = () => {
  const location = useLocation();
  const [currentScalable, setCurrentScalable] = useState<'yes' | 'no'>('no');

  useEffect(() => {
    if (window.ReactNativeWebView) {
      const meta = document.getElementById('viewport');

      if (location.pathname.includes('pdf')) {
        meta?.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes');

        setCurrentScalable('yes');
      } else if (currentScalable === 'yes') {
        meta?.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');

        setCurrentScalable('no');
      }
    }
  }, [location.pathname, currentScalable]);
};
